<template>
  <div class="w-100">
    <div class="card-header mb-3">
      <h3 class="card-title">{{$t('reports.countries_details.title')}}: {{ $route.params.country }}</h3>
      <div class="d-flex justify-content-end">
        <router-link :to="{ name: 'profile-countries' }">
          <b-button size="sm" variant="outline-primary">{{$t('reports.country_details.btn.back_to_countries_list')}}</b-button>
        </router-link>
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <b-form-group
            :label="$t('reports.filter.date_from')"
            label-for="dateFrom"
        >
          <date-range-picker v-model="dateFrom"
                             :locale="{firstDay: 1, format: 'yyyy-mm-dd'}"
                             style="width: 100%;"
                             :singleDatePicker="true"
                             :time-picker="false"
                             :ranges="false"
                             :opens="'right'">
          </date-range-picker>
        </b-form-group>
      </div>
      <div class="col-3">
        <b-form-group
            :label="$t('reports.filter.date_from')"
            label-for="dateFrom"
        >
          <date-range-picker v-model="dateTo"
                             :locale="{firstDay: 1, format: 'yyyy-mm-dd'}"
                             style="width: 100%;"
                             :singleDatePicker="true"
                             :time-picker="false"
                             :ranges="false"
                             :opens="'right'">
          </date-range-picker>
        </b-form-group>
      </div>
      <div class="col-3 d-flex align-items-end mb-3">
        <b-button class="btn" variant="secondary" @click="clearFilters">{{ $t('reports.btn.clear') }}</b-button>
        <b-button class="btn ml-2" variant="primary" @click="getReport">{{ $t('reports.btn.apply') }}</b-button>
      </div>
    </div>

    <template v-if="show">
      <div class="row mt-2">
        <div class="col-12">
          <div class="sygni-grid">
            <grid-pagination :total-count="countryDetails.totalCount"
                             :per-page="perPage"
                             :current-page="currentPage"
                             @load-items="paginationReload"></grid-pagination>
            <div class="">
              <div class="row mt-2">
                <div class="col-12">
                  <div class="table-responsive">
                    <b-table striped show-empty
                             :empty-text="$t('table.no_results')"
                             :busy="isBusy"
                             hover
                             head-variant="dark"
                             outlined
                             :no-local-sorting="true"
                             :items="countryDetails.items"
                             :fields="fields">

                      <template #table-busy>
                        <div class="text-center text-danger my-2">
                          <b-spinner class="align-middle"></b-spinner>
                          <strong>{{ $t('state.loading') }}</strong>
                        </div>
                      </template>
                    </b-table>
                  </div> <!-- #table-responsive-->
                </div>
              </div>
            </div> <!-- #card-body-->
            <grid-pagination :total-count="countryDetails.totalCount"
                             :per-page="perPage"
                             :current-page="currentPage"
                             @load-items="paginationReload"></grid-pagination>
          </div> <!-- #card questions sygni-grid-->
        </div>
      </div>
      <div class="row mt-0">
        <div class="col-12">
            <ProfileCountryDetailsTotal></ProfileCountryDetailsTotal>
          </div>
      </div>
    </template>
    <div class="spinner-wrapper" v-else>
      <b-spinner></b-spinner>
    </div>
  </div>
</template>

<script>
import GridPagination from "../../../components/grid/grid-pagination/GridPagination";
import DateRangePicker from "../../../components/DateRangePicker/components/DateRangePicker";
import ProfileCountryDetailsTotal from "./ProfileCountryDetailsTotal";
import moment from "moment";
import {mapState} from "vuex";

export default {
  components: {
    GridPagination,
    DateRangePicker,
    ProfileCountryDetailsTotal
  },
  data() {
    return {
      show: true,
      limit: 10,
      offset: 0,
      perPage: 10,
      currentPage: 1,
      fields: [
        {key: 'allDeposits', label: this.$t('table.header.reports.all_deposits')},
        {key: 'confirmedAccounts', label: this.$t('table.header.reports.confirmed_accounts')},
        {key: 'date', label: this.$t('table.header.reports.date')},
        {key: 'firstDeposit', label: this.$t('table.header.reports.firstDeposit')},
        {key: 'registrations', label: this.$t('table.header.reports.registrations')}
      ],
      items: [],
      dateFrom: {
        startDate: null
      },
      dateTo: {
        startDate: null
      }
    };
  },
  mounted() {
    if(!this.$route.params.country) {
      this.$router.push({ name: 'profile-countries' });
    } else {
      this.dateFrom = this.$route.params.date.dateFrom;
      this.dateTo = this.$route.params.date.dateTo;
      this.getReport();
    }
  },
  methods: {
    clearFilters() {
      this.dateFrom = { startDate: null };
      this.dateTo = { startDate: null };

      this.getReport();
    },
    getReport() {
      let offset = this.perPage * (this.currentPage - 1);

      const date = {
        pagination: 'limit=' + this.perPage + '&offset=' + offset,
        country: this.$route.params.country,
        dateFrom: this.dateFrom.startDate ? moment(this.dateFrom.startDate).format('YYYY-MM-DD') : null,
        dateTo: this.dateTo.startDate ? moment(this.dateTo.startDate).format('YYYY-MM-DD') : null
      }

      this.$store.dispatch('reports/getProfileCountriesDetailsReport', date);
    },
    paginationReload(data) {
      this.currentPage = data.currentPage;
      this.perPage = data.perPage;
      this.totalCount = data.totalCount;

      this.getReport();
    },
  },
  computed: {
    ...mapState({
      isBusy: (state) => state.reports.isBusy,
      countryDetails: (state) => state.reports.countryDetails,
    }),
    apiKey: function () {
      return this.$store.getters["root/apiKey"];
    }
  }
}
</script>
